/**
 * 픽업 · 수령 준비완료 (PickupReadyScreen) — 카운터 수령 대기 화면(#794).
 *
 * 시안 원본은 "Ya lo recogí" 버튼으로 로컬 종결하지만, 실제 종결은 파트너가
 * 카운터에서 Entregar 를 눌러야 발생한다. 고객이 버튼으로 스스로 종결하면 파트너
 * 기록과 어긋나므로 버튼을 두지 않고, 상태 폴링이 `seated` 를 감지하면 페이지가
 * 자동으로 {@link WaitlistDeliveredScreen} 으로 전환한다(task-9 브리프 "결정" 항목).
 *
 * @see #781 / admin#2111 설계 §7 / task-9 브리프
 */
import { MapPin, ShoppingBag } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import type { WaitlistPartyData } from '@/lib/api/waitlist';
import { WaitlistRow } from './WaitlistParts';
import type { WaitlistStrings } from './strings';

interface WaitlistPickupReadyScreenProps {
  t: WaitlistStrings;
  party: WaitlistPartyData;
}

export function WaitlistPickupReadyScreen({ t, party }: WaitlistPickupReadyScreenProps) {
  return (
    <div className="flex flex-1 flex-col overflow-y-auto">
      <div className="bg-primary px-6 pb-10 pt-12 text-center text-primary-foreground">
        <div className="mx-auto mb-5 grid size-[76px] place-items-center rounded-full bg-white/20">
          <ShoppingBag className="size-[34px]" />
        </div>
        <div className="text-3xl font-extrabold tracking-[-0.02em]">{t.pkReady2Title}</div>
        <p className="m-0 mt-2 text-[15px] leading-relaxed opacity-90">{t.pkReady2Lead}</p>
      </div>

      <div className="flex-1 px-5 pb-10 pt-6">
        <Card className="mb-[22px]">
          <CardContent className="flex flex-col gap-3.5 p-5">
            <div>
              <div className="text-xs text-muted-foreground">{t.pkOrderNumLabel}</div>
              <div className="text-[26px] font-extrabold">
                {/* order_no 누락(구서버/편집 유실 등) 시 ticket_no 로 대체 —
                    "#undefined" 노출 방지(#794 Task 9 코드리뷰 시정). */}
                <bdi dir="ltr">#{party.order_no ?? party.ticket_no}</bdi>
              </div>
            </div>
            <Separator />
            <WaitlistRow icon={<MapPin className="size-[17px]" />} label={t.veA} value={t.pkGoTo} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
